/* ------------------------------------------------------------------
 *  ガイドコンテンツに関する関数
--------------------------------------------------------------------- */

// ガイドコンテンツのTOPへ戻るボタンの表示
function sticky_page_top_btn() {
  const guide_zone = $("#guideContents");
  const page_top_btn = $("#page_top");
  if (guide_zone.length && page_top_btn.length) {
    if ($(window).scrollBottom() > guide_zone.offset().top) {
      page_top_btn.addClass("isFixed");
    } else {
      page_top_btn.removeClass("isFixed");
    }
  }
}

function displayToTopBtn() {
  $.fn.scrollBottom = function () {
    return $(window).height() + this.scrollTop();
  };
  document.addEventListener("scroll", sticky_page_top_btn, false);
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export { sticky_page_top_btn, displayToTopBtn };
